var map = {
	"./circus.svg": "./svg/circus.svg",
	"./divider-pattern-green.svg": "./svg/divider-pattern-green.svg",
	"./divider-pattern-red.svg": "./svg/divider-pattern-red.svg",
	"./divider-pattern-white.svg": "./svg/divider-pattern-white.svg",
	"./icon-arrow-button.svg": "./svg/icon-arrow-button.svg",
	"./icon-checked-mark.svg": "./svg/icon-checked-mark.svg",
	"./icon-flag-left.svg": "./svg/icon-flag-left.svg",
	"./icon-flag-right.svg": "./svg/icon-flag-right.svg",
	"./icon-flags.svg": "./svg/icon-flags.svg",
	"./icon-name-divider.svg": "./svg/icon-name-divider.svg",
	"./icon-ul-li.svg": "./svg/icon-ul-li.svg",
	"./loader.svg": "./svg/loader.svg",
	"./logo-groothart.svg": "./svg/logo-groothart.svg",
	"./logo-primary.svg": "./svg/logo-primary.svg",
	"./logo-secondary.svg": "./svg/logo-secondary.svg",
	"./logo.svg": "./svg/logo.svg",
	"./select-arrow-error.svg": "./svg/select-arrow-error.svg",
	"./select-arrow.svg": "./svg/select-arrow.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./svg sync recursive \\.svg$";